import React from 'react';
import { IMG } from '../lib/images';

// Tahitian Move official logo
// - light=true → shown on a dark background (hero, footer): use the original PNG as-is
// - light=false → shown on a light background: wrap it inside a dark rounded chip so the
//   white/turquoise artwork stays readable, preserving brand identity.
export function Logo({ light = false, className = '', size = 'md' }) {
  const heights = { sm: 36, md: 48, lg: 64 };
  const h = heights[size] || heights.md;

  if (light) {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src={IMG.logo}
          alt="Tahitian Move — Tahiti Since 1977"
          style={{ height: h }}
          className="w-auto select-none"
          draggable="false"
        />
      </div>
    );
  }

  // On light backgrounds: present logo within a dark badge so colors stay vivid.
  return (
    <div className={`flex items-center ${className}`}>
      <div
        className="bg-[#0F172A] rounded-md flex items-center justify-center px-2"
        style={{ height: h + 8 }}
      >
        <img
          src={IMG.logo}
          alt="Tahitian Move — Tahiti Since 1977"
          style={{ height: h }}
          className="w-auto select-none"
          draggable="false"
        />
      </div>
    </div>
  );
}
